<template>
  <div class="mb-2">
    <AppFilter :filters="filterConfig" :filter-submitting="filterSubmitting" @filter="handleFilter">
      <template #extra-actions>
        <b-button id="create-new-btn" variant="primary" class="create-new-btn" @click="createTaxes">
          <feather-icon icon="PlusIcon" size="15" />
          {{ $t('Create Taxes') }}
        </b-button>
      </template>
    </AppFilter>
  </div>
</template>
<script>
import { BButton } from 'bootstrap-vue';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { helper } from '@core/mixins/helper.js';
import AppFilter from '@/components/AppFilter/AppFilter.vue';

export default {
  components: {
    BButton,
    AppFilter
  },
  mixins: [helper],
  props: {
    values: {
      type: Object,
      required: true
    },
    filterSubmitting: {
      type: Boolean,
      required: true,
      default: false
    }
  },

  data() {
    return {
      taxStatus: []
    };
  },

  computed: {
    taxStatusTypeOptions() {
      return this.taxStatus.map(item => ({
        label: item.info,
        value: item.value
      }));
    },
    filterConfig() {
      return [
        {
          id: 'description',
          label: 'Tax Name',
          type: 'text',
          placeholder: 'Make a Choice'
        },
        {
          id: 'status',
          label: 'Status',
          type: 'select',
          options: this.taxStatusTypeOptions,
          placeholder: 'Make a Choice'
        }
      ];
    }
  },
  watch: {},

  async created() {
    this.taxStatus = await this.getTaxStatus();
  },

  methods: {
    handleFilter(filters) {
      this.$emit('filter', filters);
    },
    createTaxes() {
      this.$router.push({ name: 'create_taxes' });
    },
    onResetFilters(values) {
      this.resetFilters(values);
      this.filter();
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
